"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkflowFields = exports.getWorkflowFields = exports.getEntityFields = void 0;
const react_1 = require("react");
const lodash_1 = require("lodash");
const core_ui_1 = require("@sierralabs/core-ui");
const entity_ui_1 = require("@sierralabs/entity-ui");
const workflow_core_1 = require("@sierralabs/workflow-core");
const excludeList = [
    'id',
    'created',
    'createdBy',
    'modified',
    'modifiedBy',
    'deleted',
    'isDeleted'
];
function getEntityFields(entity, options = {}) {
    if (!entity) {
        return [];
    }
    const { include = [], exclude = [], prependValue = '', prependLabel = '' } = options;
    const columnFields = entity.columns.map(column => {
        return {
            label: column.displayName,
            value: column.name || (0, lodash_1.camelCase)(column.displayName)
        };
    });
    const relationFields = (entity.relations || []).map(relation => {
        return { value: relation.propertyName, label: relation.displayName };
    });
    // filter fields
    const allFields = columnFields.concat(relationFields);
    const shouldFilter = include.length > 0 || exclude.length > 0;
    const fields = !shouldFilter
        ? allFields
        : allFields.filter(field => {
            return ((include.length === 0 || include.includes(field.value)) &&
                (exclude.length === 0 || !exclude.includes(field.value)));
        });
    return fields.map(field => {
        return Object.assign(Object.assign({}, field), { value: prependValue + field.value, label: prependLabel + field.label });
    });
}
exports.getEntityFields = getEntityFields;
// includes entity, relations, and custom fields
function getWorkflowFields(entities, props) {
    const { id, tableName, filterRelations = [] } = props;
    const entity = entities.find(entity => {
        return tableName
            ? entity.tableName === tableName
            : id
                ? entity.id === id
                : false;
    });
    // get fields of matching relation entities
    const allRelationFields = ((entity === null || entity === void 0 ? void 0 : entity.relations) || []).map(relation => {
        const filterOptions = filterRelations.find(r => r.name === relation.propertyName);
        const entity = filterRelations.length === 0 || filterOptions
            ? entities.find(entity => entity.name === relation.target)
            : undefined;
        return getEntityFields(entity, Object.assign({ exclude: excludeList, prependValue: `${relation.propertyName}.`, prependLabel: `${relation.displayName} ` }, filterOptions));
    });
    // get fields of entity
    const fields = getEntityFields(entity, { exclude: excludeList });
    return fields.concat(...allRelationFields, workflow_core_1.customWorkflowFields);
}
exports.getWorkflowFields = getWorkflowFields;
function useWorkflowFields(props) {
    const { id, tableName, filterRelations } = props;
    const { entities } = (0, entity_ui_1.useEntityContext)();
    const fields = (0, react_1.useMemo)(() => {
        // only include task relation by default
        const relations = filterRelations || [
            {
                name: core_ui_1.api.getEntity('task', 'Task').propertyName,
                include: [
                    'attachments',
                    'descriptionOfChange',
                    'dueDate',
                    'files',
                    'user'
                ]
            }
        ];
        return getWorkflowFields(entities || [], {
            id,
            tableName,
            filterRelations: relations
        });
    }, [entities, id, filterRelations, tableName]);
    return fields;
}
exports.useWorkflowFields = useWorkflowFields;
//# sourceMappingURL=useWorkflowFields.js.map